import axios from 'axios';
import { API_URL } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: token ? `Bearer ${token}` : '' };
};

const currentTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (err) {
    return undefined;
  }
};

export const fetchMorningDigest = async () => {
  const timezone = currentTimezone();
  const response = await axios.get(`${API_URL}/digest/morning`, {
    headers: authHeaders(),
    params: timezone ? { timezone } : undefined,
  });
  return response.data;
};

export const acknowledgeMorningDigest = async () => {
  const timezone = currentTimezone();
  await axios.post(`${API_URL}/digest/morning/ack`, {}, {
    headers: authHeaders(),
    params: timezone ? { timezone } : undefined,
  });
};
